const encoder = new TextEncoder();
const decoder = new TextDecoder();

/**
 * Encrypt payload and return SINGLE combined value
 */


export async function decryptAESKey(encryptedAESKeyBase64, privateKey) {
  // Convert Base64 to Uint8Array
  const encryptedBytes = Uint8Array.from(
    atob(encryptedAESKeyBase64),
    c => c.charCodeAt(0)
  );

  // Decrypt using RSA-OAEP
  const decrypted = await window.crypto.subtle.decrypt(
    { name: "RSA-OAEP" },
    privateKey,
    encryptedBytes
  );

  // Return as Uint8Array (raw AES key bytes)
  return new Uint8Array(decrypted);
}


export async function generateRSAKeyPair() {
   const keyPair = await window.crypto.subtle.generateKey(
    {
      name: "RSA-OAEP",
      modulusLength: 2048, // 2048-bit key
      publicExponent: new Uint8Array([0x01, 0x00, 0x01]), // 65537
      hash: "SHA-256",
    },
    true, // keys are exportable
    ["encrypt", "decrypt"]
  );

  return keyPair;
}

export async function setupKeys() {
  const keyPair = await generateRSAKeyPair();
  const publicKeyBase64 = await exportPublicKeyBase64(keyPair.publicKey);

  return {
    publicKeyBase64,  // send this to server
    privateKey: keyPair.privateKey // keep this in memory to decrypt AES later
  };
}

export async function exportPublicKeyBase64(publicKey) {
  const spki = await window.crypto.subtle.exportKey("spki", publicKey);
  const b64 = btoa(String.fromCharCode(...new Uint8Array(spki)));
  return b64;
}

export async function encryptData(data, base64Key) {
  const keyBytes = Uint8Array.from(
    atob(base64Key),
    c => c.charCodeAt(0)
  );

  const cryptoKey = await window.crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-GCM" },
    false,
    ["encrypt"]
  );

  const iv = window.crypto.getRandomValues(new Uint8Array(12));

  const encryptedBuffer = await window.crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    cryptoKey,
    encoder.encode(JSON.stringify(data))
  );

  // Combine IV + CipherText
  const combined = new Uint8Array(
    iv.length + encryptedBuffer.byteLength
  );

  combined.set(iv, 0);
  combined.set(new Uint8Array(encryptedBuffer), iv.length);

  return btoa(String.fromCharCode(...combined));
}


//  Decrypt the API RESPONSE 

export async function decryptData(encryptedPayload, base64Key) {
  const keyBytes = Uint8Array.from(
    atob(base64Key),
    c => c.charCodeAt(0)
  );

  const cryptoKey = await window.crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-GCM" },
    false,
    ["decrypt"]
  );

  const buffer = Uint8Array.from(
    atob(encryptedPayload),
    c => c.charCodeAt(0)
  );

  const iv = buffer.slice(0, 12);
  const cipherTextWithTag = buffer.slice(12);

  const decrypted = await window.crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    cryptoKey,
    cipherTextWithTag
  );

  return JSON.parse(decoder.decode(decrypted));
}